<template lang="html">
	<div class="" id="container">
		<div class="">
			<div class="modal-container" v-if="popupConfirm">
				<div class="modal-dialog modal-dialog-centered modal-md" role="document">
					<div class="modal-content">
						<div class="modal-header title">
							<h3>Consulta buró de crédito</h3>
						</div>

						<div class="modal-body border-solid">
							<div class="row m-4">
								<div class="col-12 mb-4">
									<h4>¿Estás seguro de que deseas consultar buró de crédito?</h4>
								</div>
								<div class="col-6 text-center">
									<button class="btn btn-success" type="button" @click="ConsultarBuro()">Aceptar</button>
								</div>
								<div class="col-6 text-center">
									<button class="btn btn-red" type="button" @click="Cancelar()">Cancelar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal-container" v-if="popupAlert">
				<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header title">
							<h3>Alerta</h3>
						</div>

						<div class="modal-body">
							<div class="row m-4">
								<div class="col-12 mb-4">
									<h4>{{ msgAlert }}</h4>
								</div>
								<div class="col-12 text-center">
									<button class="btn btn-success" type="button" @click="Cancelar()">Aceptar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal-container" v-if="popupActive">
				<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
					<div class="modal-content">
						<div class="modal-header title">
							<h3>Datos Adicionales</h3>
						</div>

						<div class="modal-body">
							<form>
								<div class="row p-4">
									<div class="col-12 mb-4">
										<h4>¿El acreditado cuenta con direcciones adicionales?</h4>
										<label><span class="text-danger">*</span> Estos datos se solicitan por el banco para generar un resultado más preciso</label>
									</div>
									<div class="col-6 text-center">
										<input type="radio" name="direccionesAdicionales" v-model="direccionesAdicionales" id="direcciones-adicionales-si" value="SI">
										<label for="direcciones-adicionales-si">SI</label>
									</div>
									<div class="col-6 text-center">
										<input type="radio" name="direccionesAdicionales" v-model="direccionesAdicionales" id="direcciones-adicionales-no" value="NO">
										<label for="direcciones-adicionales-no">NO</label>
									</div>
								</div>

								<div class="mt-4" id="content-direcciones" v-if="isAdicionales">
									<div class="title p-4">
										<h3>Direcciones Adicionales</h3>
									</div>
									<div class="item-direccion p-4">
										<div class="row">
											<div class="col-12 mb-4">
												<label>Dirección 1:</label>
											</div>
										</div>

										<div class="row px-4">
											<div class="col-6 mb-3">
												<span class="span-placeholder">Calle *</span>
												<input type="text" class="vs-input" v-validate="'required'" name="CalleUno" v-model="CalleUno">
												<span class="text-danger text-sm" v-show="errors.has('CalleUno')">Campo requerido</span>
											</div>

											<div class="col-3 mb-3">
												<span class="span-placeholder">No. Exterior *</span>
												<input type="text" class="vs-input" v-validate="'required'" name="NoExtUno" v-model="NoExtUno">
												<span class="text-danger text-sm" v-show="errors.has('NoExtUno')">Campo requerido</span>
											</div>

											<div class="col-3 mb-3">
												<span class="span-placeholder">No. Interior</span>
												<input type="text" class="vs-input" name="NoIntUno" v-model="NoIntUno">
											</div>

											<div class="col-6 mb-3">
												<span class="span-placeholder">Colonia *</span>
												<input type="text" class="vs-input" v-validate="'required'" name="ColoniaUno" v-model="ColoniaUno">
												<span class="text-danger text-sm" v-show="errors.has('ColoniaUno')">Campo requerido</span>
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Delegación/Municipio *</span>
												<input type="text" class="vs-input" v-validate="'required'" name="CdDelUno" v-model="CdDelUno">
												<span class="text-danger text-sm" v-show="errors.has('CdDelUno')">Campo requerido</span>
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Estado *</span>
												<select name="cboEstadoUno" id="cboEstadoUno" v-model="cboEstadoUno" v-validate="'required'" class="vs-input">
													<option :value='estado.value' v-for="estado in listEstados" :key="">{{estado.nombre}}</option>
												</select>
												<span class="text-danger text-sm" v-show="errors.has('cboEstadoUno')">Campo requerido</span>
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Código Postal *</span>
												<input type="text" class="vs-input" v-validate="'min:5|max:5'" v-mask="'#####'" v-on:keypress="isNumber($event)" name="CPUno" v-model="CPUno">
												<!-- <vs-input class="" v-model="CPUno" name="CPUno" v-validate="'required|min:5|max:5'" v-mask="'#####'" v-on:keypress="isNumber($event)" /> -->
												<span class="text-danger text-sm" v-show="errors.has('CPUno')">El campo debe tener 13 caracteres</span>
											</div>
										</div>
									</div>

									<hr>

									<div class="item-direccion p-4">
										<div class="row">
											<div class="col-12 mb-4">
												<label>Dirección 2:</label>
											</div>
										</div>

										<div class="row px-4">
											<div class="col-6 mb-3">
												<span class="span-placeholder">Calle</span>
												<input type="text" class="vs-input" name="calle" v-model="CalleDos">
											</div>

											<div class="col-3 mb-3">
												<span class="span-placeholder">No. Exterior</span>
												<input type="text" class="vs-input" name="noExterior" v-model="NoExtDos">
											</div>

											<div class="col-3 mb-3">
												<span class="span-placeholder">No. Interior</span>
												<input type="text" class="vs-input" name="noInterior" v-model="NoIntDos">
											</div>

											<div class="col-6 mb-3">
												<span class="span-placeholder">Colonia</span>
												<input type="text" class="vs-input" name="colonia" v-model="ColoniaDos">
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Delegación/Municipio</span>
												<input type="text" class="vs-input" name="municipio" v-model="CdDelDos">
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Estado</span>
												<select name="cboEstadoDos" id="cboEstadoDos" v-model="cboEstadoDos" class="vs-input">
													<option :value='estado.value' v-for="estado in listEstados" :key="">{{estado.nombre}}</option>
												</select>
											</div>

											<div class="col-6 mb-2">
												<span class="span-placeholder">Código Postal</span>
												<input type="text" class="vs-input" v-validate="'min:5|max:5'" v-mask="'#####'" v-on:keypress="isNumber($event)" name="cp" v-model="CPDos">
												<span class="text-danger text-sm" v-show="errors.has('cboEstadoDos')">El campo debe tener 13 caracteres</span>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>

						<div class="modal-footer">
							<button class="btn btn-success" type="button" @click="GuardarAdicionales()">Guardar</button>
							<button class="btn btn-red" type="button" @click="Cancelar()">Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<vx-card class="formulario">
			<h4 class="titulo">Historial de Precalificaciones</h4>

			<br />
			<VueGoodTable 
				styleClass="vgt-table bordered" 
				:columns="columnasHistorial" 
				:rows="rows" 
				:pagination-options="{
					enabled: true,
					mode: 'records',
					perPageDropdown: [5, 25],
					dropdownAllowAll: false,
					rowsPerPageLabel: 'Mostrar',
					ofLabel: 'registros de un total de',
					pageLabel: 'page', // for 'pages' mode
					nextLabel: 'siguiente',
					prevLabel: 'anterior',
				}">
				<div slot="emptystate">
					<center>No se han encontrado resultados para tu búsqueda</center>
				</div>
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field == 'Activo'">
						<div class="rows-2">
							<span v-if="esFilaAfirme(props.row)" style="font-weight: 500; color: #49a84f">{{ props.row.estatusAfirme }}</span>
							<span v-else-if="props.row.banco!=='HSBC'" style="font-weight: 500; color: #49a84f">{{ props.row.Folio }}</span>
							<span v-else>Enviado a HSBC</span>
						</div>
						<div v-if="props.row.banco!=='HSBC' && !esFilaAfirme(props.row)" class="line-divider"></div>
						<div v-if="props.row.banco!=='HSBC' && !esFilaAfirme(props.row)" class="rows-2">
							<span>{{ props.row.textBuro }}</span>
						</div>
					</span>
					<span v-else-if="props.column.field == 'fechasRegistro'">
						<div class="rows-2">
							<span style="font-weight: 500; color: #49a84f">{{ props.row.fechaSolicitud }}</span>
						</div>
						<div v-if="props.row.banco!=='HSBC' && !esFilaAfirme(props.row)" class="line-divider"></div>
						<div v-if="props.row.banco!=='HSBC' && !esFilaAfirme(props.row)" class="rows-2">
							<span style="font-weight: 500; color: #49a84f">{{ props.row.fechaConsultaBuro }}</span>
						</div>
					</span>
					<span v-else-if="props.column.field == 'Acciones'">
						<div v-if="esFilaAfirme(props.row)" class="content-buttons">
							<button
								v-if="filaTieneOfertasAfirme(props.row)"
								class="btn btn-success btn-table"
								type="button"
								@click="verOfertasAfirme(props.row)"
							>Ver Ofertas</button>
						</div>
						<div v-else-if="props.row.banco!=='HSBC'" class="content-buttons">
							<button class="btn btn-success btn-table" @click="RegistrarAdicionales(props.row.idRegistro)">{{ props.row.textButtonAdicionales }}</button>
							<button v-if="isSupuervisor" class="btn btn-success btn-table" :disabled="!JSON.parse(props.row.isDisabled)" @click="ConfirmarBuro(props.row.idRegistro)">{{ props.row.textButtonBuro }}</button>
						</div>
					</span>

					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>

				<!-- <template slot="table-header-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <button class="fancy-btn">Action</button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template> -->
			</VueGoodTable>

			<div class="modal-container" v-if="popupOfertasAfirme">
				<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header title">
							<h3>Ofertas Afirme</h3>
						</div>
						<div class="modal-body ofertas-afirme">
							<table v-if="ofertasAfirme.length" class="vgt-table bordered">
								<thead>
									<tr>
										<th>Monto Máximo</th>
										<th>Porcentaje LTV</th>
										<th>Plazo</th>
										<th>Monto Máximo LTV</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(oferta, index) in ofertasAfirme" :key="index">
										<td>{{ formatoMontoOferta(oferta, 'montoMaximo') }}</td>
										<td>{{ formatoLtvOferta(oferta) }}</td>
										<td>{{ formatoPlazoOferta(oferta) }}</td>
										<td>{{ formatoMontoOferta(oferta, 'montoMaximoLtv') }}</td>
									</tr>
								</tbody>
							</table>
							<p v-else class="text-center mb-0">Afirme aún no ha enviado ofertas para esta precalificación.</p>
						</div>
						<div class="modal-footer">
							<button class="btn btn-success" type="button" @click="popupOfertasAfirme = false">Cerrar</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Adicionales -->
			<!-- <vs-popup fullscreen title="Datos Adicionales" :active.sync="popupActive">
				<vx-card title="Datos requeridos" class="">
					
					<h4>Adicionales</h4>
					<br />
					<div class="row w-full">
						<div class="col-md-4">
							<vs-button color="primary" @click="editarIngreso()">Editar ingreso</vs-button>
						</div>
					</div>
				</vx-card>
			</vs-popup> -->
		</vx-card>
	</div>
</template>


<script>
import VuePassword from 'vue-password'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
export default {
	components: {
		VuePassword,
		VueGoodTable,
	},
	data() {
		return {
			id: '',
			key: '',
			emailBroker: '',
			email: '',
			cantidades: [
				{ Nombre: '15', id: 15 },
				{ Nombre: '25', id: 25 },
			],
			contrasenias: [],
			cantidad: 15,
			mostrarTabla: true,
			mostrarFormulario: false,
			financiera: '',
			usuario: '',
			password: '',
			estatus: false,
			fechaAlta: '',
			ultimaActualizacion: '',
			editar: true,
			textoTiluto: 'Nueva contraseña de banco',
			isSupuervisor: false,
			rows: [],
			bancosEjecutivo: [],

			listEstados: [
				{ value: 0, nombre: 'Seleccione una opción' },
				{ value: 'AC', nombre: 'AGUASCALIENTES' },
				{ value: 'BC', nombre: 'BAJA CALIFORNIA' },
				{ value: 'BL', nombre: 'BAJA CALIFORNIA SUR' },
				{ value: 'CP', nombre: 'CAMPECHE' },
				{ value: 'CQ', nombre: 'CHIAPAS' },
				{ value: 'CJ', nombre: 'CHIHUAHUA' },
				{ value: 'OU', nombre: 'COAHUILA DE ZARAGOZA' },
				{ value: 'CW', nombre: 'COLIMA' },
				{ value: 'DI', nombre: 'DISTRITO FEDERAL' },
				{ value: 'DU', nombre: 'DURANGO' },
				{ value: 'GJ', nombre: 'GUANAJUATO' },
				{ value: 'UE', nombre: 'GUERRERO' },
				{ value: 'HD', nombre: 'HIDALGO' },
				{ value: 'JA', nombre: 'JALISCO' },
				{ value: 'EM', nombre: 'MEXICO' },
				{ value: 'IC', nombre: 'MICHOACAN DE OCAMPO' },
				{ value: 'RL', nombre: 'MORELOS' },
				{ value: 'AY', nombre: 'NAYARIT' },
				{ value: 'VO', nombre: 'NUEVO LEON' },
				{ value: 'OA', nombre: 'OAXACA' },
				{ value: 'UB', nombre: 'PUEBLA' },
				{ value: 'QU', nombre: 'QUERETARO ARTEAGA' },
				{ value: 'QR', nombre: 'QUINTANA ROO' },
				{ value: 'SP', nombre: 'SAN LUIS POTOSI' },
				{ value: 'NS', nombre: 'SINALOA' },
				{ value: 'ON', nombre: 'SONORA' },
				{ value: 'TA', nombre: 'TABASCO' },
				{ value: 'TS', nombre: 'TAMAULIPAS' },
				{ value: 'TL', nombre: 'TLAXCALA' },
				{ value: 'VZ', nombre: 'VERACRUZ' },
				{ value: 'YN', nombre: 'YUCATAN' },
				{ value: 'ZS', nombre: 'ZACATECAS' },
			],

			popupConfirm: false,
			popupActive: false,
			popupOfertasAfirme: false,
			ofertasAfirme: [],

			popupAlert: false,
			msgAlert: '',

			idSolicitud: '',

			direccionesAdicionales: '',
			isAdicionales: false,

			CalleUno: '',
			NoExtUno: '',
			NoIntUno: '',
			ColoniaUno: '',
			CdDelUno: '',
			cboEstadoUno: '0',
			CPUno: '',
			CalleDos: '',
			NoExtDos: '',
			NoIntDos: '',
			ColoniaDos: '',
			CdDelDos: '',
			cboEstadoDos: '0',
			CPDos: '',
			//bancos:[],
			// ActualizaTable: '',
		}
	},
	props: {
		ActualizaTable: {
			type: String,
			required: false,
		},
	},
	computed: {
		hayFilasAfirme() {
			return this.rows.some((row) => this.esFilaAfirme(row))
		},
		hayOfertasAfirme() {
			return this.rows.some((row) => this.esFilaAfirme(row) && this.filaTieneOfertasAfirme(row))
		},
		hayFilasOtrasInstituciones() {
			return this.rows.some((row) => !this.esFilaAfirme(row))
		},
		columnasHistorial() {
			return [
				{
					label: 'Folio Comparador',
					field: 'folioComparador',
					sortable: false,
					filterOptions: {
						styleClass: 'class1',
						enabled: true,
						placeholder: 'Folio',
						filterValue: '',
					},
				},
				{
					label: 'Banco',
					field: 'banco',
					sortable: false,
					filterOptions: {
						styleClass: 'class1',
						enabled: true,
						placeholder: 'Banco',
						filterValue: '',
					},
				},
				{
					label: 'Folio Afirme',
					field: 'folioAfirme',
					sortable: false,
					hidden: !this.hayFilasAfirme,
				},
				{
					label: 'Destino',
					field: 'destino',
					sortable: false,
					filterOptions: {
						styleClass: 'class1',
						enabled: true,
						placeholder: 'Destino',
						filterValue: '',
					},
				},
				{
					label: 'Fecha Solicitud',
					field: 'fechasRegistro',
					sortable: false,
				},
				{
					label: 'Monto Solicitado',
					field: 'montoSolicitado',
					sortable: true,
				},
				{
					label: 'Estatus',
					field: 'Activo',
					sortable: false,
					filterOptions: {
						styleClass: 'class1',
						enabled: true,
						placeholder: 'Estatus',
						filterValue: '',
					},
				},
				{
					label: 'Políticas',
					field: 'politicas',
					sortable: false,
					hidden: !this.hayFilasAfirme,
				},
				{
					label: 'Descripción',
					field: 'descripcion',
					sortable: false,
					hidden: !this.hayFilasAfirme,
				},
				{
					label: 'Acciones',
					field: 'Acciones',
					sortable: false,
					hidden: !(this.hayFilasOtrasInstituciones || this.hayOfertasAfirme),
				},
			]
		},
	},
	watch: {
		ActualizaTable: function () {
			if (this.ActualizaTable == 'actualiza') {
				this.rows = []
				this.gettabla()
			}
		},
		direccionesAdicionales: function () {

			this.isAdicionales = this.direccionesAdicionales === 'SI' && true

		}
	},

	mounted() {
		this.id = this.$route.params.id
		this.key = JSON.parse(localStorage.getItem('userInfo')).ApiKey
		this.emailBroker = JSON.parse(localStorage.getItem('userInfo')).EMail
		this.getPerfilBanco()
		this.gettabla()
	},
	methods: {
		RegistrarAdicionales(idSolicitud) {

			this.popupActive = true

			this.idSolicitud = idSolicitud
			this.getAdicionalesSolicitud(idSolicitud)
    },
		esBancoAfirme(banco, idBanco) {
			const id = Number(idBanco)
			if (id === 12) return true
			return String(banco || '').toUpperCase().indexOf('AFIRME') >= 0
		},
		esFilaAfirme(row) {
			if (!row) return false
			return this.esBancoAfirme(row.banco, row.idBanco)
		},
		filaTieneOfertasAfirme(row) {
			return !!(row && Array.isArray(row.ofertas) && row.ofertas.length)
		},
		parseJsonSeguro(valor) {
			if (valor === null || valor === undefined || valor === '') return null
			if (typeof valor === 'object') return valor
			if (typeof valor !== 'string') return null
			try {
				return JSON.parse(valor)
			} catch (e) {
				return null
			}
		},
		extraerRespuestaAfirme(element) {
			const peticion = this.parseJsonSeguro(element.Peticion || element.peticion) || {}
			let respuesta = this.parseJsonSeguro(element.Respuesta || element.respuesta)
			if (respuesta && typeof respuesta === 'object' && respuesta.objContenido) {
				respuesta = respuesta.objContenido
			}
			if (!respuesta || typeof respuesta !== 'object') respuesta = {}
			const offers = respuesta.offers || respuesta.Ofertas || respuesta.Offers || element.offers || element.Ofertas || []
			const policies = respuesta.policies || respuesta.Politicas || respuesta.Policies || element.policies || element.Politicas || []
			return {
				folio: respuesta.Folio || respuesta.folio || element.FolioAfirme || element.Folio || element.FolioExterno || element.FolioTexto || '',
				decreeStatus: respuesta.decreeStatus || respuesta.DecreeStatus || element.decreeStatus || element.Estatus || '',
				statusMessage: respuesta.statusMessage || respuesta.StatusMessage || element.statusMessage || element.Descripcion || element.Resultado || element.strInformacion || '',
				policies,
				offers: Array.isArray(offers) ? offers : this.parseJsonSeguro(offers) || [],
				destino: this.nombreDestinoAfirme(respuesta.DestinoCredito || peticion.DestinoCredito || peticion.destinoCredito || element.Destino),
				montoSolicitado: element.MontoSolicitado || respuesta.MontoSolicitado || peticion.MontoSolicitado || peticion.montoSolicitado || '',
			}
		},
		parsePoliticasAfirme(politicas) {
			if (!politicas) return ''
			if (typeof politicas === 'string') return politicas
			if (!Array.isArray(politicas)) return String(politicas)
			return politicas
				.map((item) => {
					if (item === null || item === undefined) return ''
					if (typeof item === 'string' || typeof item === 'number') return String(item)
					return item.name || item.nombre || item.description || item.descripcion || item.policy || item.mensaje || item.message || ''
				})
				.filter(Boolean)
				.join(', ')
		},
		formatearFechaHistorial(fecha) {
			if (!fecha) return ''
			let texto = ''
			if (typeof fecha === 'object' && fecha.date) texto = String(fecha.date)
			else texto = String(fecha)
			const iso = texto.substring(0, 10)
			const partes = iso.split('-')
			if (partes.length === 3 && partes[0].length === 4) return partes[2] + '/' + partes[1] + '/' + partes[0]
			return iso
		},
		nombreBancoHistorial(element) {
			const idBanco = Number(element.Banco || element.IdBanco || element.BancoId)
			const nombre = element.NombreBanco || element.BancoNombre || element.Institucion || ''
			if (idBanco === 12 || String(nombre).toUpperCase().indexOf('AFIRME') >= 0) return 'AFIRME'
			return nombre
		},
		valorCampoOferta(oferta, claves) {
			if (!oferta || typeof oferta !== 'object') return ''
			for (let i = 0; i < claves.length; i++) {
				if (oferta[claves[i]] !== undefined && oferta[claves[i]] !== null && oferta[claves[i]] !== '') {
					return oferta[claves[i]]
				}
			}
			return ''
		},
		formatoMontoOferta(oferta, tipo) {
			const claves = tipo === 'montoMaximoLtv'
				? ['montoMaximoLtv', 'MontoMaximoLTV', 'maxLtvAmount', 'maximumLtvAmount', 'max_ltv_amount', 'montoMaximoLTV']
				: ['montoMaximo', 'MontoMaximo', 'maxAmount', 'maximumAmount', 'max_amount', 'amount']
			const valor = this.valorCampoOferta(oferta, claves)
			if (valor === '') return ''
			const numero = Number(String(valor).replace(/,/g, ''))
			if (isNaN(numero)) return valor
			return numero.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
		},
		formatoLtvOferta(oferta) {
			const valor = this.valorCampoOferta(oferta, ['porcentajeLtv', 'PorcentajeLTV', 'ltv', 'ltvPercentage', 'ltvPercent', 'percentageLtv'])
			if (valor === '') return ''
			const numero = Number(String(valor).replace('%', ''))
			if (isNaN(numero)) return valor
			return numero + '%'
		},
		formatoPlazoOferta(oferta) {
			const valor = this.valorCampoOferta(oferta, ['plazo', 'Plazo', 'term', 'termMonths', 'plazoMeses'])
			if (valor === '') return ''
			return valor
		},
		nombreDestinoAfirme(destino) {
			if (destino === null || destino === undefined || destino === '') return ''
			let valor = destino
			if (typeof valor === 'object') {
				valor = valor.Nombre || valor.NombreDestino || valor.Id || ''
			}
			const texto = String(valor || '')
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toUpperCase()
				.trim()
			if (texto === 'SUSTITUCION' || texto.indexOf('SUSTITUC') >= 0 || texto.indexOf('MEJORA') >= 0) return 'Sustitución'
			if (texto === 'ADQUISICION' || texto.indexOf('ADQUISIC') >= 0) return 'Adquisición'
			const idsSustitucion = [19, 22, 25, 33, 34]
			if (idsSustitucion.indexOf(Number(valor)) >= 0) return 'Sustitución'
			if (!isNaN(Number(valor)) && String(valor).trim() !== '') return 'Adquisición'
			return String(valor)
		},
		verOfertasAfirme(row) {
			this.ofertasAfirme = (row && row.ofertas) ? row.ofertas : []
			this.popupOfertasAfirme = true
		},
		gettabla() {
			// alert('anali')
			let self = this
			var objRequestListaTabla = {
				strApiKey: this.key,
				strMetodo: 'ListaSolicitudesExternas',
				objCaso: {
					IdCaso: this.id,
				},
			}
			this.$axios
				.post('/', objRequestListaTabla, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					this.ActualizaTable = ''
					const registro = response.data.objContenido
					if (!Array.isArray(registro)) {
						this.rows = []
						return
					}

          this.rows = registro.map(element => {
            const fechaPrecalificacion = this.formatearFechaHistorial(element.Fecha)
            const fechaConsultaBuro = this.formatearFechaHistorial(element.FechaConsultaBuro)
						const idBanco = Number(element.Banco || element.IdBanco || element.BancoId)
						const banco = this.nombreBancoHistorial(element)
						const esAfirme = this.esBancoAfirme(banco, idBanco)
						const respuestaAfirme = esAfirme ? this.extraerRespuestaAfirme(element) : null
						const ofertas = respuestaAfirme && Array.isArray(respuestaAfirme.offers) ? respuestaAfirme.offers : []

						let isDisabled
						if ( element.DatosAdicionales ) {

							if ( fechaConsultaBuro ) {

								isDisabled = false

							}
							else {

								isDisabled = true

							}

						}
						else {

							isDisabled = false

						}

            return {

              idRegistro: element.Id,
							idBanco,
              folioComparador: element.Precalificacion, 
              destino: esAfirme ? (respuestaAfirme.destino || element.Destino || '') : element.Destino, 
              banco,
              folioAfirme: esAfirme ? (respuestaAfirme.folio || '') : '',
              montoSolicitado: esAfirme ? (respuestaAfirme.montoSolicitado || element.MontoSolicitado || '') : element.MontoSolicitado, 
              fechas: JSON.stringify({ fechaPrecalificacion, fechaConsultaBuro }),
							fechaSolicitud: fechaPrecalificacion,
							fechaConsultaBuro,
							textBuro: fechaConsultaBuro ? '' : 'Sin buró de crédito',
							textButtonAdicionales: element.DatosAdicionales ? 'Consultar datos' : 'Datos adicionales',
							textButtonBuro: fechaConsultaBuro ? 'Se ha consultado buró' : 'Consultar buró de crédito',
              Folio: element.FolioTexto,
							isDisabled,
							estatusAfirme: esAfirme ? (respuestaAfirme.decreeStatus || '') : '',
							politicas: esAfirme ? this.parsePoliticasAfirme(respuestaAfirme.policies) : '',
							descripcion: esAfirme ? (respuestaAfirme.statusMessage || '') : '',
							ofertas,

            }

          })

				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema4',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		getPerfilBanco() {

			let self = this
			const objRequestBroker = {
				strApiKey: this.key,
				strMetodo: 'DamePerfilBrokerBanco',
				objBrokerBanco: {
					emailBroker: this.emailBroker,
					banco: 11
				},
			}

			// console.log('DamePerfilBrokerBanco')

			this.$axios
				.post('/', objRequestBroker, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					const intEstatus = response.data.intEstatus

					if ( intEstatus ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en DamePerfilBrokerBanco',
							text: data.strError,
							color: 'danger',
							position: 'top-right',
						})

					}

					const resp = response.data.objContenido

					this.isSupuervisor = resp === 'Supervisor' && true

				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema4',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

		},
		Cancelar() {

			this.idSolicitud = ''
			this.popupActive = false

			this.direccionesAdicionales = ''
			this.isAdicionales = false

			this.popupConfirm = false

			this.popupAlert = false

		},
		getAdicionalesSolicitud(idSolicitud) {

			let self = this
			const objRequestBroker = {
				strApiKey: this.key,
				strMetodo: 'DameAdicionalesSolicitud',
				objSolicitud: { idSolicitud }
			}

			this.$axios
				.post('/', objRequestBroker, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					const intEstatus = response.data.intEstatus

					if ( intEstatus ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en DameAdicionalesSolicitud',
							text: data.strError,
							color: 'danger',
							position: 'top-right',
						})

					}

					const { datosAdicionales, direccionesAdicionales } = response.data.objContenido

					this.direccionesAdicionales = datosAdicionales
					const objDireccionesAdicionales = JSON.parse(direccionesAdicionales)

					this.CalleUno = direccionesAdicionales ? objDireccionesAdicionales.CalleUno : ''
					this.NoExtUno = direccionesAdicionales ? objDireccionesAdicionales.NoExtUno : ''
					this.NoIntUno = direccionesAdicionales ? objDireccionesAdicionales.NoIntUno : ''
					this.ColoniaUno = direccionesAdicionales ? objDireccionesAdicionales.ColoniaUno : ''
					this.CdDelUno = direccionesAdicionales ? objDireccionesAdicionales.CdDelUno : ''
					this.cboEstadoUno = direccionesAdicionales ? objDireccionesAdicionales.cboEstadoUno : ''
					this.CPUno = direccionesAdicionales ? objDireccionesAdicionales.CPUno : ''

					this.CalleDos = direccionesAdicionales ? objDireccionesAdicionales.CalleDos : ''
					this.NoExtDos = direccionesAdicionales ? objDireccionesAdicionales.NoExtDos : ''
					this.NoIntDos = direccionesAdicionales ? objDireccionesAdicionales.NoIntDos : ''
					this.ColoniaDos = direccionesAdicionales ? objDireccionesAdicionales.ColoniaDos : ''
					this.CdDelDos = direccionesAdicionales ? objDireccionesAdicionales.CdDelDos : ''
					this.cboEstadoDos = direccionesAdicionales ? objDireccionesAdicionales.cboEstadoDos : '0'
					this.CPDos = direccionesAdicionales ? objDireccionesAdicionales.CPDos : ''

				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

		},
		GuardarAdicionales() {

			let self = this
			this.$vs.loading({
				container: '#container',
				scale: 0.6,
			})

			if ( !this.direccionesAdicionales ) {

				return this.$vs.notify({
					title: 'Ocurrio un error',
					text: 'Debes seleccionar una opción',
					color: 'danger',
					position: 'top-right',
				})

			}

			if ( 
				this.direccionesAdicionales === 'SI' && 
				(
					!this.CalleUno ||
					!this.NoExtUno ||
					// !this.NoIntUno ||
					!this.ColoniaUno ||
					!this.CdDelUno ||
					!this.cboEstadoUno ||
					!this.CPUno 
				)
			) {

				return this.$vs.notify({
					title: 'Ocurrio un error',
					text: 'Debes ingresar los campos obligatorios de la direccion 1',
					color: 'danger',
					position: 'top-right',
				})

			}

			const direccionesAdicionales = {
				CalleUno: this.CalleUno,
				NoExtUno: this.NoExtUno,
				NoIntUno: this.NoIntUno,
				ColoniaUno: this.ColoniaUno,
				CdDelUno: this.CdDelUno,
				cboEstadoUno: this.cboEstadoUno,
				CPUno: this.CPUno,
				CalleDos: this.CalleDos,
				NoExtDos: this.NoExtDos,
				NoIntDos: this.NoIntDos,
				ColoniaDos: this.ColoniaDos,
				CdDelDos: this.CdDelDos,
				cboEstadoDos: this.cboEstadoDos,
				CPDos: this.CPDos,
			}

			const objRequestAdicionales = {
				strApiKey: this.key,
				strMetodo: 'GuardarAdicionalesSolicitud',
				objAdicionales: { 

					idSolicitud: this.idSolicitud,
					datosAdicionales: this.direccionesAdicionales,
					direccionesAdicionales: JSON.stringify(direccionesAdicionales)

				},
			}

			this.$axios
				.post('/', objRequestAdicionales, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					const intEstatus = response.data.intEstatus
					this.$vs.loading.close('#container .con-vs-loading')

					if ( intEstatus ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en DameAdicionalesSolicitud 1',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})

					}

					const isAdicionales = response.data.objContenido.agregaAdicionales

					if ( !isAdicionales ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en GuardarAdicionalesSolicitud 2',
							text: response.data.objContenido.strError,
							color: 'danger',
							position: 'top-right',
						})

					}

					this.$vs.notify({
						title: `Guardado exitosamente`,
						position: 'top-right',
					})

					this.popupActive = false

					this.gettabla()

				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema4',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

		},

		ConfirmarBuro(idSolicitud) {

			this.idSolicitud = idSolicitud
			this.popupConfirm = true

		},

		ConsultarBuro() {

			let self = this
			this.$vs.loading({
				container: '#container',
				scale: 0.6,
			})

			const objRequesSolicitud = {
				strApiKey: this.key,
				strMetodo: 'ConsultarBuroSolicitud',
				objSolicitud: { idSolicitud: this.idSolicitud },
			}

			this.$axios
				.post('/', objRequesSolicitud, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					const intEstatus = response.data.intEstatus
					this.$vs.loading.close('#container .con-vs-loading')

					if ( intEstatus ) {

						if ( intEstatus === 500 ) {

							this.msgAlert = response.data.strError
							this.popupAlert = true

						}

						return this.$vs.notify({
							title: 'Ocurrio un error en ConsultarBuroSolicitud',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})

					}

					this.$vs.notify({
						title: `Guardado exitosamente`,
						position: 'top-right',
					})

					this.popupConfirm = false
					this.gettabla()

				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

		},
		isNumber: function (evt) {
			evt = evt ? evt : window.event
			var charCode = evt.which ? evt.which : evt.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault()
			} else {
				return true
			}
		},
	},
}
</script>

<style scoped>
.vx-card{
padding: 0; 
}
.btn-danger,
.btn-primary{
  width: 100%;
  border-radius: 20px;
  border: #626262 1px solid;
  padding: 0.55rem;
}

.btn-red {
	background: #ff3f3f;
	color: #fff;
}

.btn-red:hover {
	background: #e03535;
}

.rows-2 {
  min-height: 48px;
}

.line-divider {
  width: 100%;
  height: 1px;
  margin-top: 0.75em;
  margin-bottom: 0.75em;
  border-bottom: solid #286090 1px;
}

.content-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.content-buttons button {
  min-height: 50px;
  font-size: 12px;
}

.modal-content {
	border: none;
}

.modal-container {

	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	overflow-x: hidden;
	overflow-y: auto;
	z-index: 100000;
	border: none !important;

}

/* .modal-container .modal-header {

} */

.modal-container .title {
	background: #006D4E;
	color: #fff;
}

.modal-container .title h3 {
	color: #fff;
}

.modal-container .modal-header h3 {
	color: #fff;
}

.modal-container .modal-body {
	padding: 0;
}

.modal-container .modal-body.border-solid {
	border-radius: 0 0 5px 5px;
	border: solid 5px #006D4E;
	border-top: none !important;
}
.btn-red {
	background: #ff3f3f;
	color: #fff;
}

.btn-red:hover {
	background: #e03535;
}

.rows-2 {
  min-height: 48px;
}

.line-divider {
  width: 100%;
  height: 1px;
  margin-top: 0.75em;
  margin-bottom: 0.75em;
  border-bottom: solid #286090 1px;
}

.content-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.content-buttons button {
  min-height: 50px;
  font-size: 12px;
}

.modal-content {
	border: none;
}

.modal-container {

	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	overflow-x: hidden;
	overflow-y: auto;
	z-index: 100000;
	border: none !important;

}

/* .modal-container .modal-header {

} */

.modal-container .title {
	background: #006D4E;
	color: #fff;
}

.modal-container .title h3 {
	color: #fff;
}

.modal-container .modal-header h3 {
	color: #fff;
}

.modal-container .modal-body {
	padding: 0;
}

.modal-container .modal-body.border-solid {
	border-radius: 0 0 5px 5px;
	border: solid 5px #006D4E;
	border-top: none !important;
}

.modal-container .modal-body label {
	font-size: 1.2rem !important;
}
.modal-container .modal-body.ofertas-afirme {
	padding: 16px;
}
</style>